/* eslint-disable react/prop-types */
import React from 'react'

const FilterItem = ({ className, children }) => {
	return (
		<li className={className}>
			<label htmlFor={children}>
				<input type='checkbox' name={children} id={children} />
				<span>{children}</span>
			</label>
		</li>
	)
}

export default FilterItem
